import { useMutation } from 'react-query'
import { get } from 'framework/api/http'

export const useGetBulkConsignmentUsers = () => {
  return useMutation(() => get(`PWBulkConsignment/GetBulkConsignmentUsers`))
}

export default useGetBulkConsignmentUsers
